var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.75C11.04 3.75 3.75 11.04 3.75 20C3.75 28.96 11.04 36.25 20 36.25C28.96 36.25 36.25 28.96 36.25 20C36.25 11.04 28.96 3.75 20 3.75ZM20 33.75C12.4183 33.75 6.25 27.5817 6.25 20C6.25 12.4183 12.4183 6.25 20 6.25C27.5817 6.25 33.75 12.4183 33.75 20C33.75 27.5817 27.5817 33.75 20 33.75ZM27.9167 20C27.9167 20.69 27.3567 21.25 26.6667 21.25H20C19.31 21.25 18.75 20.69 18.75 20V11.6667C18.75 10.9767 19.31 10.4167 20 10.4167C20.69 10.4167 21.25 10.9767 21.25 11.6667V18.75H26.6667C27.3567 18.75 27.9167 19.31 27.9167 20Z",
    fill: "#39383A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock2);
export default __webpack_public_path__ + "static/media/clock2.70b3543e.svg";
export { ForwardRef as ReactComponent };